import overlayRoutesPerGame from "@/routes/overlay.mjs";
import type { BaseRoute } from "@/routes/routes.mjs";
import globals from "@/util/global-whitelist.mjs";
import { normalizePathname } from "@/util/mod-pathname.mjs";

/**
 * Is any given route overlay 🥴
 * @param pathname - The path to test if it's an overlay route. Defaults to globals.location?.pathname, and is normalized.
 * @see {@link normalizePathname}
 */
export default function isRouteOverlay(pathname = globals.location?.pathname) {
  const normalizedPath = normalizePathname(pathname);
  for (const gameSymbol of Object.getOwnPropertySymbols(overlayRoutesPerGame)) {
    const overlayRoute = (
      overlayRoutesPerGame[
        gameSymbol as keyof typeof overlayRoutesPerGame // this shouldn't needed but the constant type is broken with strict-ts
      ] as unknown as BaseRoute[]
    ).find(({ path }) => {
      if (typeof path === "string") return path === normalizedPath;
      if (path instanceof RegExp) {
        return normalizedPath?.match(path);
      }
      return false;
    });
    if (overlayRoute) return true;
  }
  return false;
}
